import { useState } from "react"
import { cloneDeep } from "lodash"

/**
 * Allows to make CRUD operations over a list of items at "state" level.
 * You can add, remove, update and get the items in the list
 */
export function useReactiveList (dataSource) {

  const [items, setItems] = useState(dataSource ?? [])

  const addItem = item => {
    setItems([...items, item])
  }

  /**
   * It takes an object with properties and values that you want to remove from the array, and returns a
   * new array with the items that don't match the properties and values removed
   */
  const removeItem = searchableProperties => {

    const properties = Object.keys(searchableProperties)

    setItems(prev => prev.filter(item => {
      return !properties.every(property => item[property] === searchableProperties[property])
    }))
  }

  const removeItemAtIndex = index => {
    const newItems = cloneDeep(items)
    newItems.splice(index, 1)
    setItems(newItems)
    return newItems
  }

  const removeItemAtIndexConcepts = (index) => {
    setItems(prev => {
      const newItems = [...prev];
      newItems[index] = {
        ...newItems[index],
        deletedAt: new Date().toISOString()
      }
    return newItems
    })
  }
  const updateItem = (item, index) => {
    const prev = items
    const newItems = cloneDeep(prev)
    newItems.splice(index, 1, item)

    setItems(newItems)
    return newItems
  }

  const loadItems = items => {
    setItems([...items])
  }

  return { addItem, removeItem, updateItem, removeItemAtIndex,removeItemAtIndexConcepts, items, loadItems }
}
